// fe_event に全イベント共通で付ける client 情報 (デバイス種別・画面サイズ・UA)。
// event_name ごとに意味が変わる params と違い、どのイベントでも同じ意味で使えるため
// StoreEventRequest のトップレベルの field として送る
// (schema/proto/go/fe_event/v1/fe_event.proto)。
//
// 取得できなかった値は「0 や空文字」ではなくキーごと送らない。BE は未設定を NULL で保存し、
// 「取得できなかった」と「本当に 0」を BQ 上で区別できるようにする

// DeviceType の breakpoint。MediaQueryProvider の isMobile / isIPad と同じ値を使う
export const MOBILE_MAX_WIDTH = 519
export const TABLET_MAX_WIDTH = 1024

// user_agent は proto 側で max_len = 512 を validate しているため、送る前に切る
const MAX_USER_AGENT_LENGTH = 512

// StoreEventRequest のうち共通 client 情報にあたる部分の JSON 形
export type ClientInfoBody = {
	device_type: string
	viewport_width?: number
	viewport_height?: number
	screen_width?: number
	screen_height?: number
	device_pixel_ratio?: number
	user_agent?: string
}

// 画面幅から DeviceType を判定する。
// UA ではないので、PC でウィンドウを狭くしている場合も MOBILE になりうる
export const getDeviceType = (): string => {
	const width = window.innerWidth
	if (width <= MOBILE_MAX_WIDTH) return "DEVICE_TYPE_MOBILE"
	if (width <= TABLET_MAX_WIDTH) return "DEVICE_TYPE_TABLET"
	return "DEVICE_TYPE_DESKTOP"
}

// 画面サイズが取れない環境 (iframe・jsdom 等で 0 や undefined になる) では
// 誤った 0 を保存しないよう undefined にして送らない
const toPositiveNumber = (value: unknown): number | undefined =>
	typeof value === "number" && Number.isFinite(value) && value > 0
		? value
		: undefined

const toPositiveInteger = (value: unknown): number | undefined => {
	const positive = toPositiveNumber(value)
	return positive === undefined ? undefined : Math.round(positive)
}

export const getClientInfo = (): ClientInfoBody => {
	const body: ClientInfoBody = { device_type: getDeviceType() }

	const viewportWidth = toPositiveInteger(window.innerWidth)
	if (viewportWidth !== undefined) body.viewport_width = viewportWidth
	const viewportHeight = toPositiveInteger(window.innerHeight)
	if (viewportHeight !== undefined) body.viewport_height = viewportHeight

	const screenWidth = toPositiveInteger(window.screen?.width)
	if (screenWidth !== undefined) body.screen_width = screenWidth
	const screenHeight = toPositiveInteger(window.screen?.height)
	if (screenHeight !== undefined) body.screen_height = screenHeight

	const devicePixelRatio = toPositiveNumber(window.devicePixelRatio)
	if (devicePixelRatio !== undefined) {
		body.device_pixel_ratio = devicePixelRatio
	}

	const userAgent = window.navigator?.userAgent
	if (userAgent) {
		body.user_agent = userAgent.slice(0, MAX_USER_AGENT_LENGTH)
	}

	return body
}
